class ReadMore extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    if (!this.els?.trigger?.element) return
    this.listeners.add(this.els?.trigger?.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    this.els?.snippet?.element.setAttribute('aria-hidden', true)
    this.els?.extra?.element.setAttribute('aria-hidden', false)

    this.els?.trigger?.element.remove()
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore)
}
